import { createApp } from 'vue'
import i18n from '@gd/i18n'
import GameRules from './GameRules.vue'
import { loadTComponents } from '@gd/t-components'
import GdModal, { loadModalComponents } from '@gd/modal'
import '@gd/modal/dist/gd-modal.css'
import '@gd/t-components/dist/t-components.css'

// get optional initial gametype from DOM element
const domMount = document.getElementById('game-rules-weblib')

let gametype: string | undefined
if (domMount) {
  gametype = domMount.dataset.gametype
}

const app = createApp(GameRules, { gametype }).use(i18n)
app.component('gd-modal', GdModal)
loadTComponents(app)
loadModalComponents(app)
app.mount(domMount ? domMount : document.body.appendChild(document.createElement('div')))
